import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/hair-loss-blog/author/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ href: `/author/${params.slug}/`, statusCode: 301 });
  },
});
